var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInverter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.861,
    height: 29.653,
    viewBox: "0 0 23.861 29.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(6548.094 4269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(-6547.844 -4269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(2.749 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M-6514.093-4193.894l-6.173,4.8h2.826l-1.3,3.849,6.248-4.849h-2.815Z",
    transform: "translate(6523.146 4206.602)",
    fill: "none",
    stroke: "#084688",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M-6513.639-4213.293a5.887,5.887,0,0,1,3.737-.763,7.136,7.136,0,0,1,3.738,1.859",
    transform: "translate(6517.484 4223.862)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M-6528.275-4204.346l-1.042.967",
    transform: "translate(6530.875 4215.528)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M-6524.982-4127.616a7.209,7.209,0,0,0,3.7,1.841,7.014,7.014,0,0,0,3.886-.744",
    transform: "translate(6527.173 4149.992)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M-6464.238-4131.439l-.967.911",
    transform: "translate(6476.116 4153.258)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_1024",
    "data-name": "Path 1024",
    transform: "translate(0 7.148)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2,0h9.1l2.27,2.325V17.479l-2.07,2.07H2.09L0,17.386V2.415Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.420013427734375 0.4999961853027344 L 0.4999961853027344 2.608295440673828 L 0.4999961853027344 17.18373870849609 L 2.301812171936035 19.04857635498047 L 11.29042720794678 19.04857635498047 L 13.06729602813721 17.27172470092773 L 13.06729602813721 2.52894401550293 L 11.08669471740723 0.4999961853027344 L 2.420013427734375 0.4999961853027344 M 2.199095726013184 -3.814697265625e-06 L 11.29733657836914 -3.814697265625e-06 L 13.56729602813721 2.325366973876953 L 13.56729602813721 17.47883605957031 L 11.49753570556641 19.54857635498047 L 2.089646339416504 19.54857635498047 L -3.814697265625e-06 17.38583564758301 L -3.814697265625e-06 2.414745330810547 L 2.199095726013184 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.334,
    height: 4.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 1.834,
    height: 3.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    transform: "translate(5.106)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.334,
    height: 4.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 1.834,
    height: 3.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    transform: "translate(10.212)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.334,
    height: 4.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 1.834,
    height: 3.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    transform: "translate(15.318)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.334,
    height: 4.085,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 1.834,
    height: 3.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M-6441.371-4253h4.054l2.157,2.152v1.8",
    transform: "translate(6455.76 4257.085)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_1027",
    "data-name": "Path 1027",
    transform: "translate(16.417 8.024)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.144,0h4.3S3.434.423,3.423,1.237s1.021,1.1,1.021,1.1H.144s-1.111-.151-1.089-1.1S.144,0,.144,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.2238929271697998 0.4999985694885254 C 0.0602419376373291 0.5602283477783203 -0.4340212345123291 0.7808372974395752 -0.4449033737182617 1.248518586158752 C -0.4550409317016602 1.684724092483521 0.05123567581176758 1.808974981307983 0.1852757930755615 1.834158658981323 L 3.050257921218872 1.834158658981323 C 2.968244075775146 1.657810211181641 2.920209884643555 1.456920146942139 2.92328667640686 1.230108618736267 C 2.926986217498779 0.9571753740310669 3.005475282669067 0.7132221460342407 3.126694679260254 0.4999985694885254 L 0.2238929271697998 0.4999985694885254 M 0.1444566249847412 -1.430511474609375e-06 L 4.444646835327148 -1.430511474609375e-06 C 4.444646835327148 -1.430511474609375e-06 3.434276580810547 0.4226986169815063 3.423236608505249 1.236888647079468 C 3.412196636199951 2.05107855796814 4.444646835327148 2.334158658981323 4.444646835327148 2.334158658981323 L 0.1444566249847412 2.334158658981323 C 0.1444566249847412 2.334158658981323 -0.966773509979248 2.183148622512817 -0.94476318359375 1.236888647079468 C -0.9227533340454102 0.2906286716461182 0.1444566249847412 -1.430511474609375e-06 0.1444566249847412 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1028",
    "data-name": "Path 1028",
    transform: "translate(16.417 13.276)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.144,0h4.3S3.434.423,3.423,1.237s1.021,1.1,1.021,1.1H.144s-1.111-.151-1.089-1.1S.144,0,.144,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.2238929271697998 0.4999985694885254 C 0.0602419376373291 0.5602283477783203 -0.4340212345123291 0.7808372974395752 -0.4449033737182617 1.248518586158752 C -0.4550409317016602 1.684724092483521 0.05123567581176758 1.808974981307983 0.1852757930755615 1.834158658981323 L 3.050257921218872 1.834158658981323 C 2.968244075775146 1.657810211181641 2.920209884643555 1.456920146942139 2.92328667640686 1.230108618736267 C 2.926986217498779 0.9571753740310669 3.005475282669067 0.7132221460342407 3.126694679260254 0.4999985694885254 L 0.2238929271697998 0.4999985694885254 M 0.1444566249847412 -1.430511474609375e-06 L 4.444646835327148 -1.430511474609375e-06 C 4.444646835327148 -1.430511474609375e-06 3.434276580810547 0.4226986169815063 3.423236608505249 1.236888647079468 C 3.412196636199951 2.05107855796814 4.444646835327148 2.334158658981323 4.444646835327148 2.334158658981323 L 0.1444566249847412 2.334158658981323 C 0.1444566249847412 2.334158658981323 -0.966773509979248 2.183148622512817 -0.94476318359375 1.236888647079468 C -0.9227533340454102 0.2906286716461182 0.1444566249847412 -1.430511474609375e-06 0.1444566249847412 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1029",
    "data-name": "Path 1029",
    transform: "translate(16.417 18.381)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.144,0h4.3S3.434.423,3.423,1.237s1.021,1.1,1.021,1.1H.144s-1.111-.151-1.089-1.1S.144,0,.144,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.2238929271697998 0.4999985694885254 C 0.0602419376373291 0.5602283477783203 -0.4340212345123291 0.7808372974395752 -0.4449033737182617 1.248518586158752 C -0.4550409317016602 1.684724092483521 0.05123567581176758 1.808974981307983 0.1852757930755615 1.834158658981323 L 3.050257921218872 1.834158658981323 C 2.968244075775146 1.657810211181641 2.920209884643555 1.456920146942139 2.92328667640686 1.230108618736267 C 2.926986217498779 0.9571753740310669 3.005475282669067 0.7132221460342407 3.126694679260254 0.4999985694885254 L 0.2238929271697998 0.4999985694885254 M 0.1444566249847412 -1.430511474609375e-06 L 4.444646835327148 -1.430511474609375e-06 C 4.444646835327148 -1.430511474609375e-06 3.434276580810547 0.4226986169815063 3.423236608505249 1.236888647079468 C 3.412196636199951 2.05107855796814 4.444646835327148 2.334158658981323 4.444646835327148 2.334158658981323 L 0.1444566249847412 2.334158658981323 C 0.1444566249847412 2.334158658981323 -0.966773509979248 2.183148622512817 -0.94476318359375 1.236888647079468 C -0.9227533340454102 0.2906286716461182 0.1444566249847412 -1.430511474609375e-06 0.1444566249847412 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1030",
    "data-name": "Path 1030",
    transform: "translate(16.417 23.487)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.144,0h4.3S3.434.423,3.423,1.237s1.021,1.1,1.021,1.1H.144s-1.111-.151-1.089-1.1S.144,0,.144,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.2238929271697998 0.4999985694885254 C 0.0602419376373291 0.5602283477783203 -0.4340212345123291 0.7808372974395752 -0.4449033737182617 1.248518586158752 C -0.4550409317016602 1.684724092483521 0.05123567581176758 1.808974981307983 0.1852757930755615 1.834158658981323 L 3.050257921218872 1.834158658981323 C 2.968244075775146 1.657810211181641 2.920209884643555 1.456920146942139 2.92328667640686 1.230108618736267 C 2.926986217498779 0.9571753740310669 3.005475282669067 0.7132221460342407 3.126694679260254 0.4999985694885254 L 0.2238929271697998 0.4999985694885254 M 0.1444566249847412 -1.430511474609375e-06 L 4.444646835327148 -1.430511474609375e-06 C 4.444646835327148 -1.430511474609375e-06 3.434276580810547 0.4226986169815063 3.423236608505249 1.236888647079468 C 3.412196636199951 2.05107855796814 4.444646835327148 2.334158658981323 4.444646835327148 2.334158658981323 L 0.1444566249847412 2.334158658981323 C 0.1444566249847412 2.334158658981323 -0.966773509979248 2.183148622512817 -0.94476318359375 1.236888647079468 C -0.9227533340454102 0.2906286716461182 0.1444566249847412 -1.430511474609375e-06 0.1444566249847412 -1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M-6398.8-4210v3",
    transform: "translate(6419.398 4220.358)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M-6398.8-4174v2.8",
    transform: "translate(6419.398 4189.61)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M-6398.8-4139v2.815",
    transform: "translate(6419.398 4159.716)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M-6433.8-4104v1.927l-1.917,1.654h-4.061",
    transform: "translate(6454.402 4129.821)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M24.466,24.336v2.1l-2.1,1.638-15.615.037L5,26.273v-.884a2.9,2.9,0,0,0,.269-.192,2.022,2.022,0,0,0,.819-1.635,1.98,1.98,0,0,0-.859-1.587A2.637,2.637,0,0,0,5,21.825v-1.7a2.727,2.727,0,0,0,.253-.19A2.016,2.016,0,0,0,6.015,18.3a2.045,2.045,0,0,0-.8-1.565A2.556,2.556,0,0,0,5,16.579V14.767a2.269,2.269,0,0,0,1.016-1.78A2.2,2.2,0,0,0,5,11.224V9.544a3.414,3.414,0,0,0,.285-.259A2.365,2.365,0,0,0,6.015,7.7a1.981,1.981,0,0,0-.767-1.6A2.808,2.808,0,0,0,5,5.914v-1l2.043-2.1,15.147-.043,2.4,2.185V7.009",
    transform: "translate(-5 1.289)",
    fill: "none",
    stroke: "#084688",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M-6415.346-4195.749h-.729v-3.366h.729Z",
    transform: "translate(6435.298 4209.31)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M-6415.346-4195.749h-.729v-3.366h.729Z",
    transform: "translate(6435.298 4214.416)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M-6415.346-4195.937h-.729v-3.177h.729Z",
    transform: "translate(6435.298 4219.813)",
    fill: "#084688"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverter);
export default __webpack_public_path__ + "static/media/inverter.412807a6.svg";
export { ForwardRef as ReactComponent };